import { createGlobalStyle } from 'styled-components';

interface IGlobalStyleProps {
  $fontFamily?: string;
}

export const GlobalStyle = createGlobalStyle<IGlobalStyleProps>`
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;

    color: ${({ theme }) => theme.colors.text[0]};

    overflow: hidden;

    font-size: 13.222px;
    font-family: ${({ $fontFamily }) => $fontFamily};
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    text-decoration: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    border: none;
    box-shadow: 0 0 0px 1000px ${({ theme }) => theme.colors.background[0]} inset;
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text[0]};
  }

  #overlay {
    height: 0px;
  }

  /* For Firefox browser */
  * {
    scrollbar-color: ${({ theme }) => theme.colors.background[3]} ${({ theme }) => theme.colors.background[0]};
    scrollbar-width: thin;
  }

  /* ::-webkit- for Chrome and Safari browser */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.background[0]};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.background[3]};
  }

  ::-webkit-scrollbar-corner {
    background-color: ${({ theme }) => theme.colors.background[0]};
  }

  @media all and (max-width: 1440px) {
    html, body, #root {
      font-size: 12.222px;
    }
  }

  @media all and (max-width: 1280px) {
    html, body, #root {
      font-size: 9.5px;
    }
  }
`;
